<template>
    <div>
        <models-table></models-table>
    </div>
</template>
<script>
import ModelsTable from '@/components/models/ModelsTable.vue'
export default {
  components: { ModelsTable }
}
</script>
